
import React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { TableHead } from "@/components/ui/table";
import { FilterOperation } from '@/hooks/useConnectionData';

interface TableHeaderProps {
  column: string;
  sortConfig: { key: string; direction: 'asc' | 'desc' } | null;
  onSort: (column: string) => void;
  filterValue: { value: string, operation: FilterOperation } | null;
  onFilterChange: (column: string, value: string, operation: FilterOperation) => void;
}

const TableHeaderCell: React.FC<TableHeaderProps> = ({ 
  column, 
  sortConfig, 
  onSort
}) => {
  const isSorted = sortConfig?.key === column;
  const sortDirection = isSorted ? sortConfig.direction : null;

  return (
    <TableHead>
      <div 
        className="flex items-center gap-1 cursor-pointer"
        onClick={() => onSort(column)}
      >
        <span>{column}</span>
        {sortDirection === 'asc' && (
          <ArrowUp className="h-4 w-4" />
        )}
        {sortDirection === 'desc' && (
          <ArrowDown className="h-4 w-4" />
        )}
      </div>
    </TableHead>
  );
};

export default TableHeaderCell;
